(function ($, window, Drupal) {

    Drupal.behaviors.viewsListing = {
        attach: function (context, settings) {
            let $btnDetail = $('.views-listing--detail', context);
            let $btnCompact = $('.views-listing--compact', context);
            let $card = $('.view-courses-list .view-content .card', context);

            $btnDetail.hide();

            $btnDetail.on('click', function() {
                $btnDetail.hide();
                $btnCompact.show();

                $card.addClass('card--detail');
                $card.removeClass('card--compact');
            });

            $btnCompact.on('click', function() {
                $btnCompact.hide();
                $btnDetail.show();

                $card.addClass('card--compact');
                $card.removeClass('card--detail');
            });
        }
    };

})(jQuery, window, Drupal);